import { c as _c } from "react/compiler-runtime";
import { numberConvert } from "@website/utils/number-convert";
import checkCircleOutline from "@website/widget/reserve-rate/reserve-rate-footer/assets/check-circle-outline.svg";
import { ReserveRateFooterPropertiesTypes } from "@website/widget/reserve-rate/reserve-rate-footer/reserve-rate-footer.types";
import { useRouter } from "next/router";
const limitOfferCount = 1_000_000;
export const ReserveRateFooter = t0 => {
  const $ = _c(7);
  const {
    properties
  } = t0;
  const {
    offerCount,
    offerMessage
  } = properties;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <img alt="checked" className="size-6" src={checkCircleOutline?.src} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== offerCount || $[2] !== offerMessage || $[3] !== router) {
    t2 = offerMessage ?? `${Number(offerCount) < 1000000 ? numberConvert(offerCount, {
      locale: router.locale
    }) : numberConvert(limitOfferCount, {
      locale: router.locale
    })} مسافر اخیر این اقامتگاه را پیشنهاد داده اند.`;
    $[1] = offerCount;
    $[2] = offerMessage;
    $[3] = router;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="bg-transparent-success text-body-2 mt-4 flex flex-row items-center justify-start gap-2 rounded-[8px] p-4 md:w-full lg:max-w-[1200px]">{t1}<span>{t2}</span></div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};